export const API_PATH_ApiDeviceMgmtLocationUpdateMasterDeviceId = '/services/device-mgtm/apiDeviceMgmtLocationUpdateMasterDeviceId';
